/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /api/v1/users/current(.:format) */
export function apiV1UsersCurrentPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "current" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/sign_in(.:format) */
export function apiV1UsersSignInPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/verify_otp(.:format) */
export function apiV1UsersVerifyOtpPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "verify_otp" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/resend_otp(.:format) */
export function apiV1UsersResendOtpPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "resend_otp" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/sign_out(.:format) */
export function apiV1UsersSignOutPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users(.:format) */
export function apiV1UsersPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/email(.:format) */
export function apiV1UsersEmailPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "email" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/password(.:format) */
export function apiV1UsersPasswordPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/passwords(.:format) */
export function apiV1UsersPasswordsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "passwords" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/resend_confirmation(.:format) */
export function apiV1UserResendConfirmationPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "resend_confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tags/:id(.:format) */
export function apiV1TagPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tags" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/events(.:format) */
export function apiV1EventsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/events/:id(.:format) */
export function apiV1EventPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "events" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/events/:id/resend(.:format) */
export function apiV1EventResendPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "events" + "/" + id + "/" + "resend" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/events/:id/join(.:format) */
export function apiV1EventJoinPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "events" + "/" + id + "/" + "join" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/recruits/favorites(.:format) */
export function apiV1RecruitsFavoritesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "recruits" + "/" + "favorites" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/recruits/:id(.:format) */
export function apiV1RecruitPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "recruits" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/jobs/:id(.:format) */
export function apiV1JobPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/recruits/:id/applicant(.:format) */
export function apiV1RecruitsApplicantPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "recruits" + "/" + id + "/" + "applicant" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/recruits/:id/favorite(.:format) */
export function apiV1RecruitsFavoritePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "recruits" + "/" + id + "/" + "favorite" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/auth/sign_in(.:format) */
export function newApiV1AdminSessionPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/auth/sign_in(.:format) */
export function apiV1AdminSessionPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/auth/sign_out(.:format) */
export function destroyApiV1AdminSessionPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/auth/validate_token(.:format) */
export function apiV1AuthValidateTokenPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "validate_token" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/auth/webauthn_options(.:format) */
export function apiV1AuthWebauthnOptionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "webauthn_options" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/auth/webauthn_verify(.:format) */
export function apiV1AuthWebauthnVerifyPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "webauthn_verify" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/webauthn_credentials(.:format) */
export function apiV1AdminWebauthnCredentialsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "webauthn_credentials" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/webauthn_credentials/options(.:format) */
export function optionsApiV1AdminWebauthnCredentialsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "webauthn_credentials" + "/" + "options" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/webauthn_credentials/:id(.:format) */
export function apiV1AdminWebauthnCredentialPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "webauthn_credentials" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/recruits(.:format) */
export function apiV1AdminRecruitsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "recruits" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/recruits/new(.:format) */
export function newApiV1AdminRecruitPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "recruits" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/recruits/:id(.:format) */
export function apiV1AdminRecruitPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "recruits" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/staff_blogs(.:format) */
export function apiV1AdminStaffBlogsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "staff_blogs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/staff_blogs/new(.:format) */
export function newApiV1AdminStaffBlogPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "staff_blogs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/staff_blogs/:id(.:format) */
export function apiV1AdminStaffBlogPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "staff_blogs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/advices(.:format) */
export function apiV1AdminAdvicesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "advices" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/advices/new(.:format) */
export function newApiV1AdminAdvicePath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "advices" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/advices/:id(.:format) */
export function apiV1AdminAdvicePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "advices" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/interviews(.:format) */
export function apiV1AdminInterviewsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interviews" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/interviews/new(.:format) */
export function newApiV1AdminInterviewPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interviews" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/interviews/:id(.:format) */
export function apiV1AdminInterviewPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interviews" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/news(.:format) */
export function apiV1AdminNewsIndexPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "news" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/news/new(.:format) */
export function newApiV1AdminNewsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "news" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/news/:id(.:format) */
export function apiV1AdminNewsPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "news" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/lives(.:format) */
export function apiV1AdminLivesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "lives" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/lives/new(.:format) */
export function newApiV1AdminLifePath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "lives" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/lives/:id(.:format) */
export function apiV1AdminLifePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "lives" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/new_jobs(.:format) */
export function apiV1AdminNewJobsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "new_jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/new_jobs/new(.:format) */
export function newApiV1AdminNewJobPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "new_jobs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/new_jobs/:id(.:format) */
export function apiV1AdminNewJobPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "new_jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/know_hows(.:format) */
export function apiV1AdminKnowHowsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "know_hows" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/know_hows/new(.:format) */
export function newApiV1AdminKnowHowPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "know_hows" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/know_hows/:id(.:format) */
export function apiV1AdminKnowHowPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "know_hows" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/media(.:format) */
export function apiV1AdminMediaPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "media" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/media/:id(.:format) */
export function apiV1AdminMediumPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "media" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/tags/:id(.:format) */
export function apiV1AdminTagPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "tags" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/users/:id/resend_confirmation(.:format) */
export function apiV1AdminUserResendConfirmationPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + id + "/" + "resend_confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/users/:user_id/topics/:topic_id/topic_comments(.:format) */
export function apiV1AdminUserTopicTopicCommentsPath(user_id: ScalarType, topic_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + user_id + "/" + "topics" + "/" + topic_id + "/" + "topic_comments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["user_id","topic_id","format"]);
}

/** /api/v1/admin/users/:user_id/topics/:topic_id/topic_comments/:id(.:format) */
export function apiV1AdminUserTopicTopicCommentPath(user_id: ScalarType, topic_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + user_id + "/" + "topics" + "/" + topic_id + "/" + "topic_comments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["user_id","topic_id","id","format"]);
}

/** /api/v1/admin/users/:user_id/topics(.:format) */
export function apiV1AdminUserTopicsPath(user_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + user_id + "/" + "topics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["user_id","format"]);
}

/** /api/v1/admin/users/:user_id/topics/:id(.:format) */
export function apiV1AdminUserTopicPath(user_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + user_id + "/" + "topics" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["user_id","id","format"]);
}

/** /api/v1/admin/users(.:format) */
export function apiV1AdminUsersPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/users/:id(.:format) */
export function apiV1AdminUserPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/events(.:format) */
export function apiV1AdminEventsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/events/:id(.:format) */
export function apiV1AdminEventPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "events" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/event_users/:id(.:format) */
export function apiV1AdminEventUserPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "event_users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/event_pages(.:format) */
export function apiV1AdminEventPagesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "event_pages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/event_pages/:id(.:format) */
export function apiV1AdminEventPagePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "event_pages" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/messages/:message_id/message_users(.:format) */
export function apiV1AdminMessageMessageUsersPath(message_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "messages" + "/" + message_id + "/" + "message_users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["message_id","format"]);
}

/** /api/v1/admin/messages(.:format) */
export function apiV1AdminMessagesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/messages/:id(.:format) */
export function apiV1AdminMessagePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "messages" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/message_templates(.:format) */
export function apiV1AdminMessageTemplatesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "message_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/message_templates/:id(.:format) */
export function apiV1AdminMessageTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "message_templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/attachments/:id(.:format) */
export function apiV1AdminAttachmentPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "attachments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/jobs(.:format) */
export function apiV1AdminJobsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/recommends(.:format) */
export function apiV1AdminRecommendsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "recommends" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/recommends/:id(.:format) */
export function apiV1AdminRecommendPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "recommends" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/applicants(.:format) */
export function apiV1AdminApplicantsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "applicants" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/applicants/:id(.:format) */
export function apiV1AdminApplicantPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "applicants" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}
